import { config } from "../config";
import axios from "axios";

export interface Business {
  id: string;
  name: string;
  description?: string;
  phone?: string;
  email?: string;
  website?: string;
  logo_url?: string;
  rating: number;
  reviews_count?: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  owner_id: string;
  city?: string;
  street?: string;
  building?: string;
  categories?: string[];
  services?: string[];
}

export interface User {
  id: string;
  email?: string;
  country_code?: string;
  phone?: string;
  full_name: string;
  first_name?: string;
  last_name?: string;
  role: string;
  is_verified: boolean;
  phone_verified: boolean;
  created_at: string;
  updated_at: string;
  last_login_at?: string;
  business_name?: string;
  business_type?: string;
  business_address?: string;
  business_phone?: string;
  business_website?: string;
  business_logo?: string;
  business_description?: string;
  facebook_url?: string;
  instagram_url?: string;
  twitter_url?: string;
  linkedin_url?: string;
  salon_activated: boolean;
  salon_id?: string;
}

export async function getClientFavorites(
  token: string | null
): Promise<Business[]> {
  try {
    if (!token) {
      console.warn("Authorization token is missing. Skipping request.");
      return [];
    }
    const response = await axios.get(`${config.api.baseUrl}/client/favorites`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || [];
  } catch (error: any) {
    console.error("Помилка отримання улюблених майстрів:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    return [];
  }
}

export async function addClientFavorite(
  businessId: string,
  token: string | null
): Promise<boolean> {
  try {
    if (!token) {
      console.warn("Authorization token is missing. Skipping request.");
      return false;
    }
    await axios.post(
      `${config.api.baseUrl}/client/favorites/${businessId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return true;
  } catch (error: any) {
    console.error("Помилка додавання до улюблених:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    return false;
  }
}

export async function removeClientFavorite(
  businessId: string,
  token: string | null
): Promise<boolean> {
  try {
    if (!token) {
      console.warn("Authorization token is missing. Skipping request.");
      return false;
    }
    await axios.delete(`${config.api.baseUrl}/client/favorites/${businessId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return true;
  } catch (error: any) {
    console.error("Помилка видалення з улюблених:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    return false;
  }
}

export async function getBusinessesByClientLocation(
  city?: string,
  token?: string | null
): Promise<Business[]> {
  try {
    const params: any = {};
    if (city) params.city = city;

    const headers: any = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.get(
      `${config.api.baseUrl}/client/businesses`,
      {
        params,
        headers,
      }
    );
    return response.data || [];
  } catch (error: any) {
    console.error("Помилка отримання бізнесів за локацією:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    return [];
  }
}

export async function getClients(token: string | null): Promise<User[]> {
  try {
    if (!token) {
      console.warn("Authorization token is missing. Skipping request.");
      return [];
    }
    const response = await axios.get(`${config.api.baseUrl}/clients`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || [];
  } catch (error: any) {
    console.error("Помилка отримання клієнтів:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    return [];
  }
}
